import { useMemo, useState } from 'react';

// Mock provider tx-flow demo: simulates a tx hash and confirmation
export function TxDemo() {
  const [hash, setHash] = useState<string>('');
  const [status, setStatus] = useState<'idle'|'pending'|'confirmed'>('idle');
  const hasNetwork = useMemo(()=> typeof window !== 'undefined' && (window as any).ethereum, []);
  const send = async () => {
    setStatus('pending');
    const h = '0x' + Math.random().toString(16).slice(2).padEnd(64,'0');
    setHash(h);
    setTimeout(()=> setStatus('confirmed'), 1500);
  };
  return (
    <div className="space-y-2 border border-evat-gold/40 rounded p-3 text-sm">
      <div className="font-orbitron text-evat-gold">Tx Flow (Mock)</div>
      <button onClick={send} disabled={!hasNetwork} aria-label="Send mock transaction" className={`px-3 py-1 rounded border ${hasNetwork? 'border-evat-neon text-evat-neon' : 'border-neutral-700 text-neutral-500 cursor-not-allowed'}`}>Send Tx</button>
      {!hasNetwork && <div className="text-xs text-neutral-500">No wallet/provider detected. Demo uses mock hash.</div>}
      {!!hash && <div className="text-neutral-300">Hash: <span className="text-evat-neon break-all">{hash}</span></div>}
      {status!=='idle' && <div className="text-xs text-neutral-500">Status: {status}</div>}
    </div>
  );
}

export default TxDemo;



